import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import apiClient from "../api/apiClient";
import Select from "react-select";

const PlanifLines = () => {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [deliveryDate, setdeliveryDate] = useState("");
    const [nestedDate, setnestedDate] = useState("");
    const [serviceType, setserviceType] = useState("");
    const [project, setproject] = useState("");
    const [servicesType, setServicesType] = useState("");
    const [start_route, setStartRoute] = useState("");
    const [end_route, setEndRoute] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [projects, setProjects] = useState([]);
    const [message, setMessage] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const sapUser = JSON.parse(localStorage.getItem("sapUser"));
    const Company = sapUser?.CompanyDB || "";
    
     // Obtener la lista de artículos desde el backend
    const fetchItems = async () => {
        try {
            const responsePro = await apiClient.get("/sales-orders/projects");
            
            // Valores estáticos
            const staticItems = [
                { value: "DES", label: "Desayuno" },
                { value: "ALM", label: "Almuerzo" },
                { value: "MER", label: "Merienda" },
                { value: "CEN", label: "Cena" },
                { value: "LIM", label: "LIMPIEZA" },
                { value: "UTE", label: "UTENSILIOS" },
                { value: "EQU", label: "EQUIPAMIENTOS" },
            ];
            setServicesType(staticItems);

            if (!Array.isArray(responsePro.data)) {
                throw new Error("Los datos recibidos no son un array");
            }
            // Formatear los Proyectos para el select
            const formattedProjects = responsePro.data.map((item) => ({
                value: item.PrjCode,
                label: `${item.PrjName}`,
            }));
            setProjects(formattedProjects);

        } catch (err) {
            console.error("Error obteniendo artículos", err);
            setError("Error al obtener los artículos.");
        }
    };
    const getTotalNecesarioAE00 = () => {
        let total = 0;
    
        filteredOrders.forEach(order => {
            order.Orders.forEach(line => {
                if (line.ItemCode?.startsWith("AE00")) {
                    const necesario = parseFloat(line.Necesario);
                    if (!isNaN(necesario)) {
                        total += necesario;
                    }
                }
                if (
                    line.ItemCode?.startsWith("ME00") &&
                    ["S1", "S2", "S3", "S4"].some(prefix => line.ItemName?.startsWith(prefix))
                    ) {
                    const necesario = parseFloat(line.Necesario);
                    if (!isNaN(necesario)) {
                        total += necesario;
                    }
                    }

            });
        });
    
        return total.toFixed(2); // redondeado a 2 decimales si querés
    };

    // Función para obtener datos desde el backend
    const fetchInsumos = async () => {
        setLoading(true);
        try {
            const response = await apiClient.get("/planif/insumos/v2", {
                params: { project: project?.value || "", servicio: serviceType?.value || "", startDate, endDate,  start_route, end_route, company: Company }
            });

            console.log("Datos recibidos:", response.data);

            if (!Array.isArray(response.data)) {
                throw new Error("Los datos recibidos no son un array");
            }

            // Aplicar agrupación según la opción seleccionada
            const groupedData = response.data.reduce((acc, order) => {
                let key;
                    key = `${order.CardCode}-${order.IdEscuela}`;


                if (!acc[key]) {
                    acc[key] = {
                        CardCode: order.CardCode, 
                        CntctCode: order.IdEscuela,
                        Institucion: order.Name,
                        Ruta: order.Ruta,
                        MesEntrega: order.MesEntrega,
                        Semana: order.Semana,
                        Project: order.Project,
                        Localidad: order.Localidad,
                        Orders: [],
                    };
                }
                acc[key].Orders.push(order);
                return acc;
            }, {});

            const formattedData = Object.values(groupedData);
            setOrders(formattedData);
            setFilteredOrders(formattedData);
            console.log(formattedData);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching orders", err);
            setError("Error al obtener órdenes de ventas.");
        }
    };
    
    // 🔍 Filtrado dinámico
    useEffect(() => {
        fetchItems();
        if (!searchTerm) {
            setFilteredOrders(orders);
            return;
        }

        const filteredData = orders.filter((order) =>
            (order.CardName ? order.CardName.toLowerCase() : "").includes(searchTerm.toLowerCase()) || 
            (order.Name ? order.Name.toLowerCase() : "").includes(searchTerm.toLowerCase())
        );

        setFilteredOrders(filteredData);
    }, [searchTerm, orders]);

    const checkIfDataExists = async () => {
        try {
            const response = await apiClient.get("/planif/insumos/verificacion", {
                params: {
                    project: project?.value || "",
                    servicio: serviceType?.value || "",
                    startDate,
                    endDate,
                    start_route,
                    end_route,
                    company: Company
                }
            });
    
            return response.data?.existe || false; // ← tu backend debería devolver esto
        } catch (err) {
            console.error("Error validando existencia de datos:", err);
            return false; // por seguridad, si falla la validación, permitimos continuar
        }
    };

    
    // Componente expandible para mostrar líneas de orden
    const ExpandedComponent = ({ data }) => (
        <div className="p-2">
            <h6 style={{ fontSize: "12px" }}>Detalles de la Orden</h6>
            <table className="table table-sm table-bordered" style={{ fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th>Insumo</th>
                        <th>Descripción</th>
                        <th>Cantidad a Planificar</th>
                        <th>Cantidad Real</th>
                        <th>Precio</th>
                        <th>Fecha Necesaria</th>
                    </tr>
                </thead>
                <tbody>
                    {data.Orders.map((order, index) => (
                        <tr key={index}>
                            <td>{order.ItemCode}</td>
                            <td>{order.ItemName}</td>
                            <td>{order.Necesario}</td>
                            <td>{order.NecesidadReal}</td>
                            <td>{order.Precio}</td>
                            <td>{order.FechaElaboracion}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    const columns = [
        {
            name: "Proyecto",
            selector: (row) => row.Project,
            sortable: true,
            width: "200px",
        },
        {
            name: "Codigo SN",
            selector: (row) => row.CardCode,
            sortable: true,
            width: "150px",
        },
        {
            name: "Codigo Escuela",
            selector: (row) => row.CntctCode,
            sortable: true,
            width: "150px",
        },
        {
            name: "Institución",
            selector: (row) => row.Institucion,
            sortable: true,
            width: "400px",
        },
        {
            name: "Ruta",
            selector: (row) => row.Ruta,
            sortable: true,
            width: "300px",
        },
    ];

    // 📌 Función para generar JSON con la estructura correcta
    const generateJSON = () => {
        const payload = filteredOrders.map(order => ({
            "CardCode": order.CardCode,
            "ContactPersonCode": order.CntctCode,
            "DocDate": startDate || new Date().toISOString().split('T')[0],
            "DocDueDate": deliveryDate,
            "U_Ruteo": order.Ruta,
            "U_Mes": order.MesEntrega,
            "U_Semana": order.Semana,
            "U_Semanamenu": order.Semana,
            "U_distrito": order.Localidad,
            "U_InicioTras": startDate || "",
            "U_Planif_Origen": "G",
            "U_FinTras": endDate || "",
            "U_Serv": serviceType?.value || "",
            "DocumentLines": order.Orders.map(line => ({
                "ItemCode": line.ItemCode,
                "ItemDescription": line.ItemName,
                "ProjectCode": line.Project,
                "Quantity": line.Necesario,
                "WarehouseCode": line.Almacen,
                "PriceAfterVAT": line.Precio,
                "AgreementNo": line.Code,
                "U_FechaElab": line.FechaElaboracion,
                "U_Necesidad_Real": line.NecesidadReal,
                "U_FechaCarga": nestedDate
            }))
        }));
        console.log(payload);
        return payload;
    };

    // 📌 Enviar JSON al backend
    const sendDataToBackend = async () => {
        const yaExiste = await checkIfDataExists();
        if (yaExiste) {
            alert("Ya existe una planificación con estos parámetros.");
            return;
        }
        if (submitting) return; // evita doble envío
        setSubmitting(true);

        const payload = generateJSON();
        console.log(payload);
        try {
            const response = await apiClient.post("/planif/insumos/ejecucion", { orders: payload }, { timeout: 600000 });
            // Procesar la respuesta
                const results = response.data?.results || response.data || [];
                const successCount = results.filter(r => r.status === "success").length;
                const warningCount = results.filter(r => r.status === "warning").length;
                const errorCount = results.filter(r => r.status === "error").length;

                let messageText = "";
                if (successCount > 0) {
                    messageText += `${successCount} Planificaciones con éxito.\n`;
                }
                if (warningCount > 0) {
                    messageText += `${warningCount} Planificaciones sin cambios.\n`;
                }
                if (errorCount > 0) {
                    messageText += `${errorCount} errores en la planificación.\n`;
                }

                setMessage(messageText);
                if (messageText) alert(messageText);
                setError("");
                // 🔹 Limpiar los campos después del envío exitoso
                setserviceType("");     // Limpia el campo de texto
                setproject("");     // Limpia el campo de proyecto
                setEndDate("");     // Limpia el campo de proyecto
                setEndRoute("");     // Limpia el campo de proyecto
                setStartDate("");     // Limpia el campo de proyecto
                setStartRoute("");     // Limpia el campo de proyecto
                setFilteredOrders([]); // Borra la tabla de datos

        } catch (error) {
            console.error("Error al enviar los datos", error);
            alert("Error al enviar la solicitud.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="container mt-4">
            <h2>Ejecución de Insumos v2</h2>

            {error && <div className="alert alert-danger">{error}</div>}
            <div className="row">
                <div className="col-md-3">
                    <label>Fecha Inicial:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Fecha Final:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Fecha Entrega:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={deliveryDate}
                        onChange={(e) => setdeliveryDate(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Fecha Recepcion:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={nestedDate}
                        onChange={(e) => setnestedDate(e.target.value)}
                    />
                </div>
                {/* Campo de Artículo Actual con lista desplegable con búsqueda */}
                
            </div>
            <div className="row">
                <div className="col-md-3">
                    <label>Código de Proyecto:</label>
                    <Select
                        options={projects}
                        value={project}
                        onChange={setproject}
                        placeholder="Seleccione un proyecto..."
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-3">
                    <label>Tipo de Servicio:</label>
                    <Select
                        options={servicesType}
                        value={serviceType}
                        onChange={setserviceType}
                        placeholder="Seleccione un Servicio..."
                        isSearchable={true}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <label>Ruta Inicial:</label>
                    <input
                        type="number"
                        className="form-control"
                        value={start_route}
                        onChange={(e) => setStartRoute(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Ruta Final:</label>
                    <input
                        type="number"
                        className="form-control"
                        value={end_route}
                        onChange={(e) => setEndRoute(e.target.value)}
                    />
                </div>
            </div>
            <div className="mt-3">
                <strong>Total Raciones Planificadas:</strong> {getTotalNecesarioAE00()}
            </div>
            <button className="btn btn-success mt-2" onClick={fetchInsumos}>Planificar</button>
            <button className="btn btn-primary mt-2 ml-2" onClick={sendDataToBackend} disabled={submitting} > {submitting ? "Procesando..." : "Migrar a SAP"}</button>
            <DataTable
                columns={columns}
                data={filteredOrders}
                expandableRows
                expandableRowsComponent={ExpandedComponent}
                pagination
            />
        </div>
    );
};

export default PlanifLines;
